// extracted by mini-css-extract-plugin
export default {"container":"CastingFeedbackSidebar_container__QqvFL","messageWrapper":"CastingFeedbackSidebar_messageWrapper__j9oCt"};